import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import useQueryParams from 'hooks/UseQueryParams';
import { ProjectionFields } from 'pages/digitalRetailing/DigitalRetailingConstant';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { vehicleDetailsByVIN } from 'store/DigitalRetailingState';
import { RootState } from 'store/store';

const VehicleDetails: React.FC = () => {
  const queryParams = useQueryParams();

  const hasCalledNextStep = React.useRef(false);

  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { vehicleData } = useSelector((state: RootState) => state.digitalRetailingStore);

  const _VIN = queryParams.get('VIN');

  useEffect(() => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    dispatch(
      vehicleDetailsByVIN({
        requestParams: {
          type: 'car',
          projection: ProjectionFields,
          featureWithDetails: true,
        },
        VIN: _VIN || '',
      })
    );
  }, [_VIN, dispatch]);

  return vehicleData?.VIN ? (
    <>
      <div className="car-info">
        <div className="car-info__img-box">
          {vehicleData?.Images?.length > 0 ? (
            <img src={vehicleData?.Images?.[0]?.sizes?.[0]?.path} alt='Car' className='w-100' />
          ) : null}
        </div>
        <div className="car-info__content">
          {`${vehicleData?.Year} ${vehicleData?.Make} ${vehicleData?.Model} ${vehicleData?.Trim}`}
          <br/>
          <span className='lbl'>VIN:</span> {vehicleData?.VIN}
          <br/>
          <span className='lbl'>Stock:</span> {vehicleData?.StockNumber}
        </div>
      </div>
    </>
  ) : null;
};

export default VehicleDetails;
